<template>
  <v-container fluid fill-height class="project-view">
    <v-layout column align-center justify-center>
      <h2>Project not found</h2>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style scoped>
</style>
